import SectionHeading from '@/pages/home/components/SectionHeading';
import Reveal from '@/components/base/Reveal';
import { reversalItems } from '@/mocks/home';

export default function ReversalSection() {
  return (
    <section id="reversals" className="scroll-mt-24 bg-accent-50 py-16 md:py-24">
      <div className="mx-auto max-w-content px-4 md:px-6">
        <SectionHeading
          index="04"
          kicker="FLIP FLOP LOG"
          title="反转记录：被推翻的说法都在这里"
          desc="吃瓜最怕用旧结论当新事实。这一栏把「原来的说法」和「后来的事实」并排放，每一条都标明是第几次反转，避免你把中间某一帧当成结局。"
        />

        <div className="mt-12 space-y-4 md:space-y-5">
          {reversalItems.map((item, i) => (
            <Reveal key={item.round} delay={i * 70}>
              <article className="overflow-hidden rounded-lg border border-accent-200 bg-background-50">
                <div className="grid grid-cols-1 md:grid-cols-2">
                  <div className="border-b border-accent-100 p-5 md:border-b-0 md:border-r md:p-6">
                    <div className="flex items-center gap-2">
                      <span className="w-4 h-4 flex items-center justify-center text-foreground-400">
                        <i className="ri-close-circle-line" />
                      </span>
                      <span className="font-label text-xs font-semibold tracking-wide text-foreground-500">
                        原来的说法
                      </span>
                    </div>
                    <p className="mt-3 font-body text-sm leading-relaxed text-foreground-500 line-through decoration-foreground-300">
                      {item.before}
                    </p>
                  </div>

                  <div className="relative p-5 md:p-6">
                    <span className="absolute right-4 top-4 font-label text-[11px] font-semibold tracking-wide text-primary-600">
                      {item.round}
                    </span>
                    <div className="flex items-center gap-2">
                      <span className="w-4 h-4 flex items-center justify-center text-accent-600">
                        <i className="ri-lightbulb-flash-line" />
                      </span>
                      <span className="font-label text-xs font-semibold tracking-wide text-accent-700">
                        反转之后
                      </span>
                    </div>
                    <p className="mt-3 font-body text-sm leading-relaxed text-foreground-900">
                      {item.after}
                    </p>
                    <p className="mt-3 inline-flex items-center gap-1.5 rounded-full bg-primary-50 px-3 py-1 font-body text-xs text-primary-700">
                      <span className="w-3.5 h-3.5 flex items-center justify-center">
                        <i className="ri-bookmark-3-line" />
                      </span>
                      {item.note}
                    </p>
                  </div>
                </div>
              </article>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}